export enum TaxiCorporationOrderBillingsListRequestOrder {
  DISTANCE_ASC = "DISTANCE_ASC",
  DISTANCE_DESC = "DISTANCE_DESC",
  HIGHWAY_CHARGE_ASC = "HIGHWAY_CHARGE_ASC",
  HIGHWAY_CHARGE_DESC = "HIGHWAY_CHARGE_DESC",
  HALTING_AMOUNT_ASC = "HALTING_AMOUNT_ASC",
  HALTING_AMOUNT_DESC = "HALTING_AMOUNT_DESC",
  HUMAN_ID_ASC = "HUMAN_ID_ASC",
  HUMAN_ID_DESC = "HUMAN_ID_DESC",
  BILLING_MODEL_ASC = "BILLING_MODEL_ASC",
  BILLING_MODEL_DESC = "BILLING_MODEL_DESC",
  DISTANCE_RATE_ASC = "DISTANCE_RATE_ASC",
  DISTANCE_RATE_DESC = "DISTANCE_RATE_DESC",
  DISTANCE_AMOUNT_ASC = "DISTANCE_AMOUNT_ASC",
  DISTANCE_AMOUNT_DESC = "DISTANCE_AMOUNT_DESC",
  TOTAL_AMOUNT_ASC = "TOTAL_AMOUNT_ASC",
  TOTAL_AMOUNT_DESC = "TOTAL_AMOUNT_DESC",
}

export enum TaxiCorporationOrderBillingsListRequestStatus {
  CREATED = "CREATED",
  ACCEPTED = "ACCEPTED",
  REJECTED = "REJECTED",
  REOPENED = "REOPENED",
  REOPEN_REQUEST_SENT = "REOPEN_REQUEST",
}

export enum TaxiCorporationOrderBillingsListRequestBillingModel {
  ABA = "ABA",
  SABS = "SABS",
  AB = "AB",
  OTHER = "OTHER",
}

export enum TaxiCorporationOrderBillingsListRequestBillingType {
  PUB_RAILY_2_TAXI = "PUB_RAILY_2_TAXI",
  PRIV_CARGO_2_TAXI = "PRIV_CARGO_2_TAXI",
  PRIV_TAXI_2_RAILY = "PRIV_TAXI_2_RAILY",
}

export type TaxiCorporationOrderBillingsListQueryParams = {
  limit: number;
  offset: number;
  order?: TaxiCorporationOrderBillingsListRequestOrder;
  humanId?: number;
  planEntryHumanIds?: number;
  dateSince?: string;
  dateTo?: string;
  cargoCompany?: string;
  excludeCargoCompany?: string;
  passenger?: string;
  status?: TaxiCorporationOrderBillingsListRequestStatus;
  billingModel?: TaxiCorporationOrderBillingsListRequestBillingModel;
  billingType?: TaxiCorporationOrderBillingsListRequestBillingType;
  responsibleTaxi?: string;
};

type TaxiCorporationOrderBillingsListRequest = {
  taxiCorporationUuid: string;
  limit: number;
  offset: number;
  order?: TaxiCorporationOrderBillingsListRequestOrder;
  humanId?: number;
  planEntryHumanIds?: number;
  dateSince?: string;
  dateTo?: string;
  cargoCompany?: string;
  excludeCargoCompany?: string;
  passenger?: string;
  status?: TaxiCorporationOrderBillingsListRequestStatus;
  billingModel?: TaxiCorporationOrderBillingsListRequestBillingModel;
  billingType?: TaxiCorporationOrderBillingsListRequestBillingType;
  responsibleTaxi?: string;
};

export default TaxiCorporationOrderBillingsListRequest;
